export default __webpack_public_path__ + "static/media/point_left.1be9cfcb.svg";